import React, { Component, useEffect } from "react";

export const Redirect = () => {
    useEffect(() => {

        if (window.location.hostname === "localhost") {
            window.location.href = "/login";
            return;
        }
        window.location.href = "/";
    }, [])
    return (
        <div>
            <h1>Redirecting...</h1>
        </div>
    );
}

export default Redirect;